import { MRACPageContent } from '@zillow/zrs-military-rent-affordability-calculator';
import React from 'react';

var BlockMilitaryRentCalculator = function BlockMilitaryRentCalculator(_ref) {
  var attrs = _ref.attrs;
  return /*#__PURE__*/React.createElement(MRACPageContent, attrs);
};
var MilitaryRentCalculator = BlockMilitaryRentCalculator;

export { MilitaryRentCalculator as default };
